import Vue from 'vue';

import { CourseId } from '@/openapi/enum';

import MasterApiUtility from '@/classes/common/MasterApiUtility';
import SectionData from '@/classes/data/SectionData';

// CourseProgressMixinで使用する想定
export default Vue.extend({

  name: 'SectionMixin',

  data(): {
    sectionCourseId: CourseId | null;
    sections: SectionData[]
  } {
    return {
      sectionCourseId: null,
      sections: [],
    };
  },

  computed: {
    firstSectionNo(): number {
      return this.sections[0].sectionNo;
    },
    lastSection(): SectionData {
      return this.sections[this.sections.length - 1];
    },
    lastSectionNo(): number {
      return this.lastSection.sectionNo;
    },
    lastSectionUnitNo(): number {
      return this.lastSection.unitCount - 1;
    }
  },

  methods: {
    async loadSections(courseId: CourseId): Promise<void> {
      if (courseId === this.sectionCourseId) return;
      this.sectionCourseId = courseId;
      this.sections = await MasterApiUtility.getSections(courseId);
    },

    isLastSection(sectionNo: number): boolean {
      return sectionNo === this.lastSectionNo;
    },

    isLastUnit(sectionNo: number, unitNo: number): boolean {
      const section = this.getSection(sectionNo);
      return section.unitCount === unitNo;
    },

    getSection(sectionNo: number): SectionData {
      const section = this.sections.find(s => s.sectionNo === sectionNo);
      if (section === undefined) throw new Error;
      return section;
    }

  }

});
